export const ALL_CATEGORIES = 'all'
export const MIN_MULTIPLIER = 0.1
export const STEP_MULTIPLIER = 0.01
export const REFERENCE_PRICE = 100
export const LOWER_BOUND_MULTIPLIER = 0.8
export const UPPER_BOUND_MULTIPLIER = 1.2
